import { Tooltip } from "@mui/material";
import DownloadChip from "../../../Common/DownloadChip";
import React from "react";

function Certificate({ name, onDownload, label = null }) {
    if (!name) return null;

    return (
        <Tooltip title="Download certificate" arrow>
            <DownloadChip
                label={label || name}
                className="chip"
                variant="outlined"
                color="primary"
                filename={`${name}.pdf`}
                download={onDownload}
            />
        </Tooltip>
    );
}

export default Certificate;
